// Focus team view — today's progress + streaks for everyone; managers also see each person's blocks.
import { useEffect, useState } from "react";
import axios from "axios";
import { Flame, Loader2, ChevronDown, ChevronRight, Check } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api/me/focus/team";

function Row({ r, mgmt }) {
  const [open, setOpen] = useState(false);
  const pct = r.total ? Math.round((r.done / r.total) * 100) : 0;
  const canOpen = mgmt && r.blocks?.length;
  return (
    <div className="border-t border-white/[0.05]" data-testid={`focus-team-row-${r.user_id}`}>
      <button onClick={() => canOpen && setOpen((o) => !o)} className={`w-full flex items-center gap-3 px-1 py-2 text-left ${canOpen ? "hover:bg-white/[0.02]" : "cursor-default"}`}>
        {canOpen ? (open ? <ChevronDown className="w-3.5 h-3.5 text-slate-400" /> : <ChevronRight className="w-3.5 h-3.5 text-slate-500" />) : <span className="w-3.5" />}
        <span className="text-[12.5px] text-slate-100 w-40 truncate">{r.name}</span>
        <div className="flex-1 h-1.5 rounded-full bg-white/[0.06] overflow-hidden"><div className="h-full bg-teal-400/80 transition-[width] duration-500" style={{ width: `${pct}%` }} /></div>
        <span className="text-[11px] font-mono text-slate-300 w-16 text-right" data-testid={`focus-team-progress-${r.user_id}`}>{r.has_plan ? `${r.done}/${r.total}` : "no plan"}</span>
        <span className={`text-[11px] inline-flex items-center gap-1 w-12 justify-end ${r.streak ? "text-amber-300" : "text-slate-600"}`} title="Weekday streak (6 of 8 slots done)" data-testid={`focus-team-streak-${r.user_id}`}><Flame className="w-3 h-3" />{r.streak}</span>
      </button>
      {open && <div className="pl-8 pb-2 space-y-1">{r.blocks.map((b) => (
        <div key={b.id} className={`flex items-center gap-2 text-[11.5px] ${b.done ? "text-slate-500 line-through" : "text-slate-300"}`}>
          <span className="font-mono text-[10.5px] text-slate-500 w-20">{b.start}–{b.end}</span>{b.done && <Check className="w-3 h-3 text-teal-300" />}<span className="truncate">{b.title}</span>
        </div>))}</div>}
    </div>
  );
}

export default function FocusTeam() {
  const [d, setD] = useState(null);
  useEffect(() => { axios.get(API, { withCredentials: true }).then((r) => setD(r.data)).catch(() => setD({ rows: [] })); }, []);
  if (!d) return <div className="px-4 py-5 text-[12px] text-slate-500 flex items-center gap-2"><Loader2 className="w-3.5 h-3.5 animate-spin" />Loading team…</div>;
  return (
    <div className="px-4 py-3 border-t border-white/[0.05]" data-testid="focus-team">
      <div className="flex items-center justify-between pb-1 text-[10px] uppercase tracking-wider font-mono text-slate-400">
        <span>Team today</span><span>{d.is_mgmt && d.rows.some((r) => r.has_plan) ? "Click a name to see their plan" : "Progress and streaks"}</span>
      </div>
      {d.rows.length ? d.rows.map((r) => <Row key={r.user_id} r={r} mgmt={d.is_mgmt} />) : <div className="py-5 text-center text-[12px] text-slate-500" data-testid="focus-team-empty">No one has built a Focus plan yet.</div>}
    </div>
  );
}
